// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-coiling-machines/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springCoilingMachinesEN: PageEntry = {
  id: "post.federwindeautomaten",
  locale: "en",
  slug: "spring-coiling-machines",
  seo: {
    title: "Glossary: Spring coiling machines explained simply | Dietz GmbH",
    description: "Automatic spring coiling machines are specialised machines used for the automatic production of springs. These machines enable a precise and efficient manufacturing process in whic",
  },
  type: "post",
  h1: "Glossary: Spring coiling machines explained simply",
  intro: "Automatic spring coiling machines are specialised machines used for the automatic production of springs. These machines enable a precise and efficient manufacturing process in which wire is automatically coiled, bent and cut to achieve the desired spring shape. Spring coiling machines play a crucial role in the mass production of springs for various applications, from industrial machinery to electronic devices. Automating this process contributes to cost efficiency and consistency in spring manufacturing.",
  blocks: [

  ],
};
